/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostOptimizationCloudAccountSummaryRequest {
    getFixupPrototypeFunction() { return CostOptimizationCloudAccountSummaryRequest.fixupPrototype; }

    static newInstance(model: Partial<CostOptimizationCloudAccountSummaryRequest>): CostOptimizationCloudAccountSummaryRequest {
        let obj = Object.assign(new CostOptimizationCloudAccountSummaryRequest(), model);
        CostOptimizationCloudAccountSummaryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostOptimizationCloudAccountSummaryRequest>): CostOptimizationCloudAccountSummaryRequest {
        if (!model) return null;
        return CostOptimizationCloudAccountSummaryRequest.newInstance(<CostOptimizationCloudAccountSummaryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostOptimizationCloudAccountSummaryRequest) {
        if (!obj) return;

        models.CostOptimizationCloudAccountSummaryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostOptimizationCloudAccountSummaryRequest): boolean {
        Object.setPrototypeOf(obj, CostOptimizationCloudAccountSummaryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.page === undefined) {
            this.page = 0;
        }
        if (this.limit === undefined) {
            this.limit = 0;
        }
    }

    /**
     * page number.Example 'page': 1
     */
    page: number;

    /**
     * records limits.Example 'limit': 10
     */
    limit: number;

    /**
     * currency type
     */
    currency: string;

    /**
     * Cloud account type
     */
    cloud_account_type: Array<string>;

    /**
     * Cloud account id
     */
    cloud_account_id: Array<string>;

}
